import React, { lazy, Suspense } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { CurrentProjectContainer } from "./style";
import { reduxForm } from "redux-form";
import { BoxLoading } from "../../../../../components/loading";
import getUserIdentification from "../../../../../assets/getUserIdentification";
const UserInfo = lazy(() => import("../userInfo"));

const CurrentProject = props => {
  const { user, project, userPremiumState, teamOrPanelName } = props;
  return (
    <CurrentProjectContainer>
      <Suspense fallback={<BoxLoading />}>
        <UserInfo
          user={user}
          userPremiumState={userPremiumState}
          project={project}
          teamOrPanelName={teamOrPanelName}
        />
      </Suspense>
    </CurrentProjectContainer>
  );
};

const mapStateToProps = store => {
  return {
    userPremiumState: store.Init.data.premium_state
  };
};

const CurrentProjectComponent = reduxForm({
  form: "add_project"
})(CurrentProject);

export default connect(mapStateToProps)(withRouter(CurrentProjectComponent));
